import { Injectable } from "@angular/core";
import { catchError, Observable, tap, throwError } from "rxjs";
import { RequestType } from "../../common/enums/RequestType";
import { BaseApiService } from "../services/base-api-service";
import { Rating } from "../interfaces/Rating";
import { ApiType } from "../enums/api-type";


@Injectable({ providedIn: 'root' })
export class RateAPI {
  constructor(private readonly apiClient: BaseApiService) {

  }


  deleteRate(parameters: {
    rate: Rating,
  }): Observable<void> {
    let listDataUrl = [parameters.rate.id]
    return this.apiClient.call<any, void>({
      apiType: ApiType.DELETE_RATE,
      requestType: RequestType.DELETE,
      listDataUrl: listDataUrl
    }).pipe(
      tap(response => {
        console.log(response);
      }),
      catchError(error => {
        console.log(error);
        return throwError(() => error)
      })
    )
  }


}
